const executionStepTranslations = {
  status: {
    values: {
      pending: "Ausstehend",
      running: "Läuft",
      completed: "Erfolgreich",
      failed: "Fehlgeschlagen",
      skipped: "Übersprungen",
    },
  },
  actionType: {
    values: {
      createNote: "Notiz erstellen",
      sendCustomerMessage: "Kundennachricht senden",
      createActivity: "Aktivität erstellen",
      updateField: "Feld aktualisieren",
      sendEmail: "E-Mail senden",
      changeStatus: "Status ändern",
      sendBeaOrFax: "beA-Nachricht/Fax senden",
      createDocument: "Dokument erstellen",
      createBookingEntry: "Buchungseintrag erstellen",
      createInquiryToCustomer: "Kundenanfrage erstellen",
      createWireTransfer: "Überweisung erstellen",
    },
  },
};

export default executionStepTranslations;
